import { DocumentTemplatesDeleteFileData } from "@interfaces/company/document-templates";
import { documentTemplateService } from "@services/document-templates-service";
import { useMutation, useQueryClient } from "react-query";
import { documentTemplatesQueryKeys } from "./queryKeys";

export const useDeleteDocumentTemplatesFileMutation = () => {
  const queryClient = useQueryClient();

  return useMutation(
    (data: DocumentTemplatesDeleteFileData) =>
      documentTemplateService.deleteFile(data),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(documentTemplatesQueryKeys.all);
      },
    }
  );
};
